export const COOKIES = Symbol("COOKIES");
export const WINDOW = Symbol("WINDOW");
export const UUID = Symbol("UUID");
